"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import DisablingButton from "../../components/disabling_button";
import ReactUtils from "../../react_utils";
import { documentGroupingServiceGroupByAttachments } from "../data/types/Api";
import { DocumentGroupingServiceGroupByAttachmentsResponse_OutcomeType } from "../data/types/Pb";
const bem = ReactUtils.makeBem("document-types");
function possibleError(state) {
  if (!state.errorMessage) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "span",
    {
      role: "alert",
      className: "alert-box--caution " + bem("__group-by-attachments-error"),
      children: state.errorMessage
    }
  );
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      grouping: false,
      errorMessage: null
    });
    __publicField(this, "groupByAttachments", () => {
      this.setState({ grouping: true, errorMessage: null });
      return documentGroupingServiceGroupByAttachments({
        documentBatchId: this.props.documentBatch.id
      }).then(
        (response) => {
          if (response.outcome.type === DocumentGroupingServiceGroupByAttachmentsResponse_OutcomeType.Success) {
            return Promise.resolve(
              this.props.onGrouped(response.outcome.success.redirectToDashboard)
            ).catch(() => {
              this.setState({
                grouping: false,
                errorMessage: "Grouping by attachment may have finished, but the batch couldn't be reloaded. Reload the page before continuing."
              });
            });
          }
          this.setState({
            grouping: false,
            errorMessage: response.outcome.error.message
          });
          return Promise.resolve(this.props.onRefused()).catch(() => {
          });
        },
        () => {
          this.setState({
            grouping: false,
            errorMessage: "Grouping by attachment failed. Nothing was changed \u2014 please try again."
          });
        }
      );
    });
  }
  render() {
    if (!this.props.available) {
      return possibleError(this.state);
    }
    return /* @__PURE__ */ jsxs("span", { "data-component": "GroupByAttachmentsButton", children: [
      /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "button--progress right " + bem("__update-and-continue-button") + " " + bem("__group-by-attachments-button") + (this.props.className ? " " + this.props.className : ""),
          disabled: this.state.grouping,
          disabledText: "Grouping...",
          onClick: this.groupByAttachments,
          children: "Group by Email Attachment"
        }
      ),
      possibleError(this.state)
    ] });
  }
}
